import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AvatarMenu from 'components/AvatarMenu';
import EventCreateCard from 'components/EventCreateCard';
import Loader from 'components/Loader';

import logo from '../../assets/thalo_logo.png';
import wiggle from '../../assets/wiggle_inverse.svg';

import './FirstEventWalkthrough.scss';

const WALKTHROUGH_ANIMATION_MS = 2700;

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

const FirstEventWalkthrough = () => {
	const navigate = useNavigate();
	const [creating, setCreating] = useState(false);
	// the events list replaces this screen as soon as the event is recorded, so the animation
	// has to finish before the create is sent
	const startAnimation = () => {
		setCreating(true);
		return wait(WALKTHROUGH_ANIMATION_MS);
	};
	const handleCreateEvent = event => navigate(`/events/${event.id}/dashboard`);
	const creatingClass = creating ? 'creating-event' : '';
	return (
		<div className={`FirstEventWalkthrough ${creatingClass}`}>
			<div className="left">
				<img src={logo} className="logo" alt="thalo logo" />
				<div className="page-title">
					Create Your&nbsp;
					<br />
					First Event
				</div>
			</div>
			<div className="right">
				<EventCreateCard
					onSubmitStart={startAnimation}
					onCreate={handleCreateEvent}
					onCreateFailed={() => setCreating(false)}
				/>
			</div>
			<AvatarMenu />
			<img className="wiggle-inverse" src={wiggle} alt="wiggle-inverse" />
			<div className="background" />
			<div className="overlay">{creating && <Loader />}</div>
		</div>
	);
};

export const FirstEventWalkthroughSkeleton = () => {
	return (
		<div className="FirstEventWalkthrough">
			<div className="left">
				<div className="page-title">
					Create Your&nbsp;
					<br />
					First Event
				</div>
			</div>
			<img className="wiggle-inverse" src={wiggle} alt="wiggle-inverse" />
			<div className="background" />
			<div className="overlay" />
		</div>
	);
};

export default FirstEventWalkthrough;
